import { quote } from '../data/portfolio';
import { FadeUp } from './Reveal';

export default function QuoteSection() {
    return (
        <section className="relative z-10 bg-ink py-28 md:py-40" data-testid="quote-section">
            <div className="mx-auto max-w-4xl px-6">
                <FadeUp>
                    <div className="relative rounded-3xl border border-white/10 bg-panel/60 p-9 md:p-16">
                        <span className="absolute -top-7 left-8 font-display text-[7rem] leading-none text-neon/25 select-none">
                            “
                        </span>
                        <span className="absolute right-6 top-4 h-4 w-4 border-r border-t border-neon/40" />
                        <span className="absolute bottom-4 left-6 h-4 w-4 border-b border-l border-neon/40" />
                        <blockquote className="font-display text-2xl font-semibold leading-snug text-snow md:text-[2.1rem]">
                            {quote.text}
                        </blockquote>
                        {quote.punchline && (
                            <p className="mt-6 font-display text-2xl font-extrabold uppercase tracking-tight text-neon md:text-[2.4rem]" data-testid="quote-punchline">
                                {quote.punchline}
                            </p>
                        )}
                        <footer className="mt-8">
                            <p className="font-mono text-xs uppercase tracking-[0.24em] text-neon">
                                {quote.author}
                            </p>
                            <p className="mt-1.5 text-xs text-mist">{quote.role}</p>
                        </footer>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
